import type { ToolCallResult, ToolDefinition, ToolGroup } from './types';
import { type ToolCtx, withToolCtx } from './context';
import { toolText } from './tool-helpers';

export type Registry = {
  list(): ToolDefinition[];
  call(tool: string, args: Record<string, unknown>, ctx: ToolCtx): Promise<ToolCallResult>;
};

/**
 * Bundle a set of ToolGroups into a Registry. The Registry runs each tool call
 * inside an `AsyncLocalStorage` frame so handler bodies can call
 * `mcpApiRequest()` without taking ctx as a parameter.
 */
export function buildRegistry(groups: ToolGroup[]): Registry {
  return {
    list() {
      return groups.flatMap((g) => g.definitions());
    },

    async call(tool, args, ctx) {
      return withToolCtx(ctx, async () => {
        for (const group of groups) {
          const result = await group.handle(tool, args);
          if (result) return result;
        }
        return toolText(`Unknown tool: ${tool}`);
      });
    },
  };
}
